import React, {useEffect} from 'react';

/* assets */
import CylanaLogo from '../../../../assets/images/logo_light.png'
import CylanaLogoDark from '../../../../assets/images/logo_dark.png'
import { errorFallbackSvg } from 'v2/assets/svg/errorFallbackSvg';

/* state management */
import { useSelector, useDispatch } from 'react-redux';
import useIntlMessage from 'components/util-components/useIntMessage';
import {setIsErrorBoundaryActive} from "../../../../store/slices/utilSlice";

const ErrorFallback = () => {
    const IntlMessage = useIntlMessage();
    const dispatch = useDispatch();
    const currentTheme = useSelector(state => state.theme.currentTheme)

    useEffect(() => {
        dispatch(setIsErrorBoundaryActive(true));
    }, []);

    const handleErrorFallback = () => {
        window.location.href = '/app/dashboards/default';
        dispatch(setIsErrorBoundaryActive(false));
    }

  return (
    <div className="error-fallback-container">
      <div className="error-fallback-card">
        <div className="error-fallback-header">
          <div>
            {currentTheme === 'light' ? <img src={CylanaLogo} className="header-logo" style={{height: "25px"}}/> : <img src={CylanaLogoDark} className="header-logo" style={{height: "25px"}}/>}
          </div>
        </div>

        <div className="error-fallback-body">
          <h1 className="error-fallback-title">{IntlMessage("error.fallback.title")}</h1>
          <p className="error-fallback-message">
            {IntlMessage("error.fallback.description")}
          </p>
          <div className="error-fallback-illustrationWrapper">
            {errorFallbackSvg()}
          </div>
        </div>

        <div className="error-fallback-footer">
          <button className="error-fallback-button" onClick={handleErrorFallback}>
            {IntlMessage("error.fallback.button.text")}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ErrorFallback;